export const SWEEPSTAKES_MOCK_DATA = {
  unauthenticated: {
    id: 'fifa-2026-unauthenticated',
    title: 'Enter to Win FIFA World Cup 2026™ Tickets!',
    description: 'Join thousands of Home Depot customers competing for the ultimate FIFA World Cup 2026™ experience.',
    theme: 'FIFA',
    logo: 'https://placehold.co/44x98/000000/FFFFFF?text=FIFA',
    expirationDate: '04/22/2026',
    status: 'New',
  },
  notOptedIn: {
    id: 'fifa-2024',
    title: 'WIN FIFA WORLD CUP TICKETS!',
    description: 'Complete challenges to earn entries for a chance to win World Cup tickets.',
    theme: 'FIFA',
    logo: 'https://placehold.co/44x98/000000/FFFFFF?text=FIFA',
    heroImage: 'https://placeholder.pics/svg/957x262/7a3de7-f07153/ffffff-Placeholder',
    expirationDate: '4/09/2026',
    termsAndConditions: '**Important Details About the Sweepstakes:**\n\n'
      + '* This sweepstakes will run for a duration of three weeks (03/19/2026 - 04/09/2026)\n\n'
      + '* If selected as a winner, you will be contacted over email or phone to confirm your personal details and '
      + 'match selections\n\n'
      + '* The prizes included in this sweepstakes cannot be redeemed for cash or credit',
    status: 'New',
    isOptedIn: false,
    completedSteps: 0,
    totalSteps: 4,
    messageComplete: 'GOAL! Bonus entry earned.',
    messageNotComplete: 'Complete all 4 entries, earn a 5th on us!',
    steps: [
      {
        id: 'survey',
        title: 'Take a Survey',
        subtitle: 'To edit your personal details or match selections, please call (770) 433-8211',
        iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
        completed: false,
      },
      {
        id: 'push-notifications',
        title: 'Turn on Notifications',
        subtitle: null,
        iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
        completed: false,
        ctaTitle: 'Turn on Push Notifications',
      },
      {
        id: 'store-mode',
        title: 'Experience Store Mode',
        subtitle: null,
        iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
        completed: false,
        ctaTitle: 'Open Store Mode',
      },
      {
        id: 'qualifying-purchase',
        title: 'Purchase via the App',
        subtitle: null,
        iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
        completed: false,
      },
    ],
    ctaTitle: 'Take Survey',
    ctaHref: null,
    ctaOnclick: null,
  },
  partiallyCompleted: {
    id: 'fifa-2024',
    title: 'WIN FIFA WORLD CUP TICKETS!',
    description: 'Complete challenges to earn entries for a chance to win World Cup tickets.',
    theme: 'FIFA',
    logo: 'https://placehold.co/44x98/000000/FFFFFF?text=FIFA',
    heroImage: 'https://placeholder.pics/svg/957x262/7a3de7-f07153/ffffff-Placeholder',
    expirationDate: '4/09/2026',
    termsAndConditions: '**Important Details About the Sweepstakes:**\n\n'
      + '* This sweepstakes will run for a duration of three weeks (03/19/2026 - 04/09/2026)\n\n'
      + '* If selected as a winner, you will be contacted over email or phone to confirm your personal details and '
      + 'match selections\n\n'
      + '* The prizes included in this sweepstakes cannot be redeemed for cash or credit',
    status: '2 of 4 Completed',
    isOptedIn: true,
    completedSteps: 2,
    totalSteps: 4,
    messageComplete: 'GOAL! Bonus entry earned.',
    messageNotComplete: 'Complete all 4 entries, earn a 5th on us!',
    steps: [
      {
        id: 'survey',
        title: 'Take a Survey',
        subtitle: 'To edit your personal details or match selections, please call (770) 433-8211',
        description: 'No entries earned for more chances to win.',
        iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
        completed: true,
        instructions: 'Complete the survey to activate your sweepstakes entry.',
      },
      {
        id: 'push-notifications',
        title: 'Turn on Notifications',
        subtitle: null,
        description: 'To turn on push notifications for The Home Depot app, you will need to go into your '
          + 'device\'s Settings. If you haven\'t done so already, make sure to install the Home Depot app.',
        iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
        completed: true,
        instructions: '**To Turn On Notifications:**\n\n'
          + '1. Open the Settings app\n'
          + '2. Tap on Notifications\n'
          + '   -If you have an Android device, tap App Notifications to see your installed apps\n'
          + '3. Select The Home Depot app under Notification Style\n'
          + '4. Tap the Allow Notifications toggle to turn it on\n'
          + '   -The toggle will turn green\n\n'
          + '**Important Details on Managing Alerts:**\n\n'
          + 'From the Lock Screen:\n'
          + '* Tap a single notification to open the corresponding app\n'
          + '* Touch and hold the notification for quick access without opening the app\n'
          + '* If you missed an alert, swipe up from the middle of your Lock Screen\n\n'
          + '**From the Home Screen:**\n'
          + '* Tap the banner as it appears to open the corresponding app',
        ctaTitle: 'Turn on Push Notifications',
        eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_notifications',
      },
      {
        id: 'store-mode',
        title: 'Experience Store Mode',
        subtitle: null,
        description: 'To use Store Mode, you must be in a physical Home Depot store. After opening the app '
          + 'while in the store, navigate to "Store Mode" on the bottom of your screen.\n\n'
          + 'It will automatically activate when you enter the store to help you find items faster and '
          + 'navigate the store more efficiently.',
        iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
        completed: false,
        instructions: '**To Experience Store Mode:**\n\n'
          + '1. Open The Home Depot app\n'
          + '   -You must be in store to use Store Mode\n'
          + '2. Select your store\n'
          + '   -The app may automatically detect it\n'
          + '3. Search for a product\n'
          + '4. Tap on the map icon to see its location within the store\n\n'
          + '**Important Details About Store Mode:**\n\n'
          + 'Store Mode can be used while shopping at any Home Depot store location. Store Mode helps '
          + 'you plan your trip efficiently and unlocks the following benefits:\n\n'
          + '* Pre-select desired items online\n'
          + '* Get personalized product recommendations\n'
          + '* Optimize your in-store route for faster shopping',
        ctaTitle: 'Open Store Mode',
        eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_store-mode',
      },
      {
        id: 'qualifying-purchase',
        title: 'Purchase via the App',
        subtitle: null,
        description: null,
        iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
        completed: false,
        instructions: 'Make a qualifying purchase through The Home Depot app to complete this step.',
        ctaTitle: 'Shop Now',
        eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_shop',
      },
    ],
    ctaTitle: null,
    ctaHref: null,
    ctaOnclick: null,
  },
  fullyCompleted: {
    id: 'fifa-2024',
    title: 'WIN FIFA WORLD CUP TICKETS!',
    description: 'Complete challenges to earn entries for a chance to win World Cup tickets.',
    theme: 'FIFA',
    logo: 'https://placehold.co/44x98/000000/FFFFFF?text=FIFA',
    heroImage: 'https://placeholder.pics/svg/957x262/7a3de7-f07153/ffffff-Placeholder',
    expirationDate: '4/09/2026',
    termsAndConditions: '**Important Details About the Sweepstakes:**\n\n'
      + '* This sweepstakes will run for a duration of three weeks (03/19/2026 - 04/09/2026)\n\n'
      + '* If selected as a winner, you will be contacted over email or phone to confirm your personal details and '
      + 'match selections\n\n'
      + '* The prizes included in this sweepstakes cannot be redeemed for cash or credit',
    status: '4 of 4 Completed',
    isOptedIn: true,
    completedSteps: 4,
    totalSteps: 4,
    messageComplete: 'GOAL! Bonus entry earned.',
    messageNotComplete: 'Complete all 4 entries, earn a 5th on us!',
    steps: [
      {
        id: 'survey',
        title: 'Take a Survey',
        subtitle: 'To edit your personal details or match selections, please call (770) 433-8211',
        description: 'No entries earned for more chances to win.',
        iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
        completed: true,
        instructions: 'Complete the survey to activate your sweepstakes entry.',
      },
      {
        id: 'push-notifications',
        title: 'Turn on Notifications',
        subtitle: null,
        description: 'To turn on push notifications for The Home Depot app, you will need to go into your '
          + 'device\'s Settings. If you haven\'t done so already, make sure to install the Home Depot app.',
        iconUrl: 'https://placehold.co/44x98/000000/FFFFFF?text=FIFA',
        completed: true,
        instructions: '**To Turn On Notifications:**\n\n'
          + '1. Open the Settings app\n'
          + '2. Tap on Notifications\n'
          + '   -If you have an Android device, tap App Notifications to see your installed apps\n'
          + '3. Select The Home Depot app under Notification Style\n'
          + '4. Tap the Allow Notifications toggle to turn it on\n'
          + '   -The toggle will turn green\n\n'
          + '**Important Details on Managing Alerts:**\n\n'
          + 'From the Lock Screen:\n'
          + '* Tap a single notification to open the corresponding app\n'
          + '* Touch and hold the notification for quick access without opening the app\n'
          + '* If you missed an alert, swipe up from the middle of your Lock Screen\n\n'
          + 'From the Home Screen:\n'
          + '* Tap the banner as it appears to open the corresponding app',
        ctaTitle: 'Turn on Push Notifications',
        eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_notifications',
      },
      {
        id: 'store-mode',
        title: 'Experience Store Mode',
        subtitle: null,
        description: 'To use Store Mode, you must be in a physical Home Depot store. After opening the app '
          + 'while in the store, navigate to "Store Mode" on the bottom of your screen.\n\n'
          + 'It will automatically activate when you enter the store to help you find items faster and '
          + 'navigate the store more efficiently.',
        iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
        completed: true,
        instructions: '**To Experience Store Mode:**\n\n'
          + '1. Open The Home Depot app\n'
          + '   -You must be in store to use Store Mode\n'
          + '2. Select your store\n'
          + '   -The app may automatically detect it\n'
          + '3. Search for a product\n'
          + '4. Tap on the map icon to see its location within the store\n\n'
          + '**Important Details About Store Mode:**\n\n'
          + 'Store Mode can be used while shopping at any Home Depot store location. Store Mode helps '
          + 'you plan your trip efficiently and unlocks the following benefits:\n\n'
          + '* Pre-select desired items online\n'
          + '* Get personalized product recommendations\n'
          + '* Optimize your in-store route for faster shopping',
        ctaTitle: 'Open Store Mode',
        eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_store-mode',
      },
      {
        id: 'qualifying-purchase',
        title: 'Purchase via the App',
        subtitle: null,
        description: null,
        iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
        completed: true,
        instructions: 'Make a qualifying purchase through The Home Depot app to complete this step.',
        ctaTitle: 'Shop Now',
        eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_shop',
      },
    ],
    ctaTitle: 'View Details',
    ctaHref: null,
    ctaOnclick: null,
  },
};

export const SWEEPSTAKES_OPT_IN_CONTENT = {
  title: 'WIN FIFA WORLD CUP TICKETS!',
  content: 'Want to be there when the world watches history unfold? Here\'s your chance to win exclusive '
    + 'FIFA World Cup tickets—and the more you participate, the better your chances!\n\n'
    + '**How It Works**\n\n'
    + 'Earn entries by completing fun and simple tasks. Each task you complete adds more entries to your '
    + 'name, boosting your odds of winning the ultimate soccer experience.\n\n'
    + '**The More You Do, The Better Your Odds!**\n\n'
    + 'Track your progress, unlock achievements, and climb the leaderboard. Every action brings you '
    + 'closer to the pitch.\n\n'
    + '**To Get Started**\n\n'
    + 'Enter the sweepstakes and earn your first entry by taking the survey below!\n\n'
    + '**The Winning Prizes**\n\n'
    + '**First Prize:** One winner and guest will receive an all expenses paid trip to the World Cup '
    + 'Finals in New York (July 18-20, 2026), and a FIFA World Cup backyard makeover!\n\n'
    + '* Roundtrip flights and accommodations\n'
    + '* Visa gift card for food and beverage\n'
    + '* Official FIFA World Cup gifting\n'
    + '* Backyard makeover by The Home Depot\n\n'
    + '**Second Prize:** Ten winners will receive a pair of match tickets in preferred market of choice '
    + '(travel not included).\n\n'
    + '**Third Prize:** Around 800 winners will receive an official FIFA World Cup Replica Ball!',
  ctaTitle: 'Take Survey',
  termsText: 'I agree to the terms and conditions',
  associateText: 'I confirm I am not an associate',
};

export const SWEEPSTAKES_SURVEY_CONTENT = {
  title: 'SURVEY',
  content: '',
  ctaTitle: 'Let\'s Do This!',
};

export const SWEEPSTAKES_DETAILS_CONTENT = {
  title: 'Sweepstakes Details',
  initialParagraph: 'You\'ve officially joined the sweepstakes! Earn more entries for a better chance to win by '
    + 'completing the tasks below.\n\nAll additional entries are optional and can be completed in any order of events.',
  stepsHeader: 'To Earn Sweepstakes Entries:',
  expiresText: 'Expires 4/09/2026',
  termsAndConditions: '**Important Details About the Sweepstakes:**\n\n'
    + '• This sweepstakes will run for a duration of three weeks (03/19/2026 - 04/09/2026)\n\n'
    + '• If selected as a winner, you will be contacted over email or phone to confirm your personal details and '
    + 'match selections\n\n'
    + '• The prizes included in this sweepstakes cannot be redeemed for cash or credit',
};